// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoFocusController from "./auto_focus_controller"
application.register("auto-focus", AutoFocusController)

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import BulkSelectionController from "./bulk_selection_controller"
application.register("bulk-selection", BulkSelectionController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import CompletionController from "./completion_controller"
application.register("completion", CompletionController)

import DashboardController from "./dashboard_controller"
application.register("dashboard", DashboardController)

import DaterangeController from "./daterange_controller"
application.register("daterange", DaterangeController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FormController from "./form_controller"
application.register("form", FormController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import KChartController from "./k_chart_controller"
application.register("k-chart", KChartController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import NoteAutosaveController from "./note_autosave_controller"
application.register("note-autosave", NoteAutosaveController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import ReviewedController from "./reviewed_controller"
application.register("reviewed", ReviewedController)

import TestController from "./test_controller"
application.register("test", TestController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TradingTagsController from "./trading_tags_controller"
application.register("trading-tags", TradingTagsController)
